'use client'

import { useState, useEffect } from 'react'
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import Header from "@/components/Header"

export default function BookingPage() {
  const [formData, setFormData] = useState({
    street: '',
    city: '',
    state: '',
    zipCode: ''
  })
  const [showCalendly, setShowCalendly] = useState(false)

  // Function to capitalize first letter of each word
  const capitalizeWords = (str: string) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase())
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    if (name === 'state') {
      // Convert to uppercase and limit to 2 characters
      const stateValue = value.toUpperCase().slice(0, 2)
      setFormData(prev => ({
        ...prev,
        [name]: stateValue
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: name === 'zipCode' ? value : capitalizeWords(value)
      }))
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const formattedAddress = `${formData.street}, ${formData.city}, ${formData.state} ${formData.zipCode}`

    // Load Calendly script
    const script = document.createElement('script')
    script.src = 'https://assets.calendly.com/assets/external/widget.js'
    script.onload = () => {
      window.Calendly?.initInlineWidget({
        url: 'https://calendly.com/linda-theguardiannotary/30min',
        parentElement: document.getElementById('calendly-embed'),
        prefill: {
          customAnswers: {
            a1: formattedAddress
          }
        }
      })
    }
    document.body.appendChild(script)
    setShowCalendly(true)
  }

  return (
    <>
      <Header />
      <main className="min-h-screen bg-white pt-24">
        <section className="container mx-auto px-6 py-16">
          {!showCalendly ? (
            <>
              <h1 className="mb-12 text-center text-4xl font-bold text-navy-900">Schedule Your Notary Service</h1>
              <div className="mx-auto max-w-2xl">
                <p className="mb-8 text-center text-lg text-gray-700">
                  Please provide the address where you'd like the notary service to take place:
                </p>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input
                    name="street"
                    value={formData.street}
                    onChange={handleInputChange}
                    placeholder="Street Address"
                    required
                    className="border-lavender-200 focus:border-rose-300 focus:ring-rose-300"
                  />
                  <Input
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="City/Town"
                    required
                    className="border-lavender-200 focus:border-rose-300 focus:ring-rose-300"
                  />
                  <div className="grid grid-cols-2 gap-4">
                    <Input
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      placeholder="State (e.g., CA)"
                      required
                      maxLength={2}
                      className="border-lavender-200 focus:border-rose-300 focus:ring-rose-300 uppercase"
                    />
                    <Input
                      name="zipCode"
                      value={formData.zipCode}
                      onChange={handleInputChange}
                      placeholder="ZIP Code"
                      required
                      pattern="[0-9]{5}"
                      className="border-lavender-200 focus:border-rose-300 focus:ring-rose-300"
                    />
                  </div>
                  <Button
                    type="submit"
                    className="w-full bg-navy-800 text-white hover:bg-navy-900"
                  >
                    Continue to Scheduling
                  </Button>
                </form>
              </div>
            </>
          ) : (
            <div id="calendly-embed" className="mx-auto" style={{ minWidth: '320px', height: '700px' }} />
          )}
        </section>
      </main>
    </>
  )
}
